import { render, staticRenderFns } from "./create-v2.vue?vue&type=template&id=16e9a03f&scoped=true&"
import script from "./create-v2.vue?vue&type=script&lang=js&"
export * from "./create-v2.vue?vue&type=script&lang=js&"
import style0 from "./create-v2.vue?vue&type=style&index=0&id=16e9a03f&prod&lang=css&"
import style1 from "./create-v2.vue?vue&type=style&index=1&id=16e9a03f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e9a03f",
  null
  
)

export default component.exports